import { useEffect, useState } from "react"
import '../CSS/DashboardTemp.css'
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./footer";
import { NavLink } from 'react-router-dom';
import MySideBar from "./MySideBar";
import NavBar from "./NavBar";


const MyDownloads = () => {
    const [isLoader, setIsLoader] = useState(true);
    setTimeout(() => {
        setIsLoader(false);
    }, 3000);

    useEffect(() => {
        if (window.location.toString().includes("/user/downloads") && !isLoader) {
            document.getElementById("my-downloads-sidebar-link").classList.add("active")
        }
    }, [isLoader])



    return (
        <div>
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <div className="dashboard row dark" id="dashboard">
                    <MySideBar />
                    <div id="content">
                        <NavBar isPencil={false} />

                        <div>These are my downloads</div>
                    </div>
                </div>


            )}
            <Footer />
        </div>
    )
}

export default MyDownloads;